import ChallengeTypeStickerPhoto from './ChallengeTypeStickerPhoto';

export default ChallengeTypeStickerPhoto;
